import React from 'react';
import { Form, Formik, FormikProps } from 'formik';
import { useHistory, useLocation } from 'react-router';
import get from 'lodash/get';
import qs from 'qs';

import * as CategoryModule from 'modules/category';
import * as SystemModule from 'modules/system';

import * as Types from '../types';

interface FormValues extends Types.IForm.Filter {
}

interface IChildren extends FormikProps<FormValues> {
  clear: (values: FormValues) => void;
}

interface IProps {
  onSuccess?: () => void;
  onError?: (error: { message: string }) => void;
  onFinally?: () => void;

  children(props: IChildren): JSX.Element;
}

const Update: React.FC<IProps> = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const { filter = {} } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const Category = CategoryModule.Hooks.useList();
  const { language } = SystemModule.Hooks.useLanguage();

  let resetFormFn: any = null;
  const bindResetForm = (resetForm) => {
    resetFormFn = resetForm;
  };

  const setParams = (values?: FormValues) => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    history.push({
      pathname: location.pathname,
      search: qs.stringify({
        ...query,
        page: undefined,
        filter: {
          tin: values?.tin || undefined,
          application_id: values?.application_id || undefined,
          status: values?.status || undefined,
          pin: values?.pin || undefined,
          number: values?.number || undefined,
          document_id: values?.document_id || undefined,
          category_id: get(values, 'category.value'),
          document_type: values?.document_type || undefined,
          organization: values?.organization || undefined,
          organization_id: values?.organization_id || undefined,
        }
      })
    });
  };

  const handleSubmit = (values: FormValues) => {
    setParams(values);
  };

  const clear = (values: FormValues) => {
    setParams(values);
    resetFormFn && resetFormFn(values);
  };

  const category = get(Category.entities, `[${get(filter, 'category_id')}]`);
  const organizationId = get(filter, 'organization_id');


  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        tin: get(filter, 'tin') || '',
        pin: get(filter, 'pin') || '',
        number: get(filter, 'number') || '',
        document_id: get(filter, 'document_id'),
        category: get(filter, 'category_id') ? { label: get(category, `[title][${language}]`), value: get(category, 'id' )} : undefined,
        document_type: get(filter, 'document_type'),
        organization: get(filter, 'organization') || '',
        organization_id: organizationId || undefined,
      }}
      validateOnMount
      enableReinitialize
    >
      {(props: FormikProps<FormValues>) => {
        bindResetForm(props.setValues);
        return (
          <Form>
            {children({ ...props, clear })}
          </Form>
        );
      }}
    </Formik>
  );
};

export default Update;
